const pesoSymbol = '₱';
exports.pesoSymbol = pesoSymbol;